<template>
  <div>
    <section class="parameters">
      <nav class="parameters__nav">
        <router-link class="parameters__nav-box" to="/parameters/profile" tag="div">
          <svg class="parameters__icon parameters__icon--large">
            <use href="@/assets/sprite.svg#icon-user"></use>
          </svg>
          <ul class="parameters__nav-entry">{{ $t('parameters.profil.title') }}
            <li class="parameters__nav-sentry">{{ $t('parameters.profil.infos') }}</li>
            <li class="parameters__nav-sentry">{{ $t('parameters.profil.society') }}</li>
            <li class="parameters__nav-sentry">{{ $t('parameters.profil.password') }}</li>
          </ul>
        </router-link>

        <router-link v-if="$can('read', 'users')" class="parameters__nav-box" to="/parameters/users" tag="div">
          <svg class="parameters__icon parameters__icon--large" :class="{'parameters__icon--white': isUserSelected}">
            <use href="@/assets/sprite.svg#icon-group"></use>
          </svg>
          <ul class="parameters__nav-entry">{{ $t('parameters.users.title') }}
            <li class="parameters__nav-sentry">{{ $t('parameters.users.listUsers') }}</li>
            <li class="parameters__nav-sentry">{{ $t('parameters.users.manageUsers') }}</li>
          </ul>
        </router-link>

        <router-link v-if="$can('read', 'groupabilities')" class="parameters__nav-box" to="/parameters/groupability" tag="div">
          <svg class="parameters__icon parameters__icon--large">
            <use href="@/assets/sprite.svg#icon-user-secret"></use>
          </svg>
          <ul class="parameters__nav-entry"> {{ $t('parameters.groupAbility.title') }}
            <li class="parameters__nav-sentry">{{ $t('parameters.groupAbility.listGroupAbilities') }}</li>
            <li class="parameters__nav-sentry">{{ $t('parameters.groupAbility.manageGroupAbilities') }}</li>
          </ul>
        </router-link>

        <router-link  v-if="$can('read', 'queueprestashops')" class="parameters__nav-box" to="/parameters/syncprestanode" tag="div">
          <svg class="parameters__icon parameters__icon--large" :class="{'parameters__icon--white': isUserSelected}">
            <use href="@/assets/sprite.svg#icon-synchro"></use>
          </svg>
          <ul class="parameters__nav-entry">{{ $t('parameters.syncPrestaNode.title') }}
            <li class="parameters__nav-sentry">{{ $t('parameters.syncPrestaNode.errorSync') }}</li>
            <li class="parameters__nav-sentry">{{ $t('parameters.syncPrestaNode.manageErrorSync') }}</li>
          </ul>
        </router-link>
      </nav>
      <main class='parameters__main'>
        <transition name="slide-fade" >
        <router-view></router-view>
        </transition>
      </main>
    </section>
  </div>
</template>

<style scoped>
.slide-fade-enter-active {
  transition: all .7s ease;
}
.slide-fade-leave-active {
  transition: all .0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
</style>

<script>
export default {
  data: function () {
    return {
      isProfileSelected: false,
      isUserSelected: false,
      isOption1: false,
      isOption2: false,
      isOption3: false,
      isOption4: false,
      isOption5: false,
      isOption6: false
    }
  }
}
</script>
